// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__Q-gbi"};